import React from 'react'
export default ({ isLoading }) => {
	return isLoading
		? <div>Loading...</div>
		: '';
}


// WEBPACK FOOTER //
// ./src/components/Loading/Loading.jsx